import { useEffect, useState } from "react";
import { useAccount } from "wagmi";

export const useLedgerLive = () => {
  const { connector } = useAccount();

  const [isLedgerInjected, setIsLedgerInjected] = useState(false);

  useEffect(() => {
    setIsLedgerInjected(window?.ethereum?.isLedgerLive || /Ledger/i.test(navigator.userAgent));
  }, []);

  const isLedgerConnected = connector?.id === "com.ledger";

  const isLedgerLiveENV = isLedgerInjected && isLedgerConnected;

  return { isLedgerConnected, isLedgerInjected, isLedgerLiveENV };
};

export default useLedgerLive;
